module.exports = __webpack_public_path__ + "static/media/email-clicked.c2f5e712.svg";